import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { appEnvironment } from '../config/appEnvironment';
import { getBearerToken } from '@/app/cookies';

const RTKTagTypes = [ 'exchangeList', 'subscriptionStatus', 'premiumSubscription' ] as const;

export const rtkApi = createApi({
    reducerPath: 'api',
    baseQuery: fetchBaseQuery({
        baseUrl: appEnvironment.API_URL,
        prepareHeaders: headers => {
            const token = getBearerToken();
            if (token) headers.set('Authorization', `${token}`);

            const locale = localStorage.getItem('i18nextLng') ?? 'ru';

            headers.set('locale', locale);

            return headers;
        },
    }),
    tagTypes: RTKTagTypes,
    endpoints: _ => ({}),
});

type RTKInject = ReturnType<typeof rtkApi.injectEndpoints>['injectEndpoints'];
export type RTKEndpointBuilder = Parameters<RTKInject>[0]['endpoints'];
export type AppRTKEndpointBuilder = Parameters<RTKEndpointBuilder>[0];
